
$(document).ready(function(){
  var $grid = $('#grid-articles');

  // init Masonry
  function initMasonry() {
    $grid.masonry({
      itemSelector      : '.grid-item',
      columnWidth       : '.grid-sizer',
      gutter            : '.gutter-sizer',
      percentPosition   : true,
      transitionDuration: 300,
    });

    // Refresh layout and transition after each image load
    // checkLoad();
  }
  initMasonry();

});
